export class Funcao {
    constructor({
      id = null,
      nome = null,
      atividades = null,
      servidorDoEstado = null,
      ativo = null,
    }) {
      this.id = id;
      this.nome = nome;
      this.atividades = atividades;
      this.servidorDoEstado = servidorDoEstado;
      this.ativo = ativo;
    }
    static Build() {
      return new Funcao({
        id: null,
        nome: null,
        servidorDoEstado: null,
        ativo: null,
      });
    }
  }
  